import { render, staticRenderFns } from "./UserTcIdentityModal.vue?vue&type=template&id=93194584"
import script from "./UserTcIdentityModal.vue?vue&type=script&lang=js"
export * from "./UserTcIdentityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports